import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64e74c2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-summary" }
const _hoisted_2 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Marks and Notes", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "唛头", -1))
const _hoisted_5 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Number and Kind of Packages", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "装运包装与数量", -1))
const _hoisted_8 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Description of Goods", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "品名", -1))
const _hoisted_11 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Goods Weight（KGS）", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "毛重（公斤）", -1))
const _hoisted_14 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Measurement（CBM）", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "尺码（立方米）", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_el_form_item, {
        class: "marks-notes",
        prop: "MarksNotes",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.MarksNotes,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.MarksNotes) = $event)),
            type: "textarea",
            rows: 5,
            resize: "none",
            trim: false,
            upperCase: true,
            red: _ctx.reds && _ctx.reds.contains('MarksNotes')
          }, null, 8, ["modelValue", "red"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_el_form_item, {
        class: "packages-number",
        prop: "PackagesNumber",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.PackagesNumber,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.PackagesNumber) = $event)),
            number: true,
            pattern: "[0-9]",
            greaterThanNumber: 0,
            red: _ctx.reds && _ctx.reds.contains('PackagesNumber')
          }, null, 8, ["modelValue", "red"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        class: "packages-kind",
        prop: "PackagesKind",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.PackagesKind,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.PackagesKind) = $event)),
            "fetch-suggestions": _ctx.getPackageKinds,
            valueKey: "Label",
            red: _ctx.reds && _ctx.reds.contains('PackagesKind'),
            "trigger-on-focus": true,
            deleteOption: true,
            checkDeleteOption: (it) => it.Data.IsHistory,
            onHandleDeleteOption: _ctx.handleDeleteContact
          }, null, 8, ["modelValue", "fetch-suggestions", "red", "checkDeleteOption", "onHandleDeleteOption"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        class: "packages-number-kind",
        prop: "PackagesNumberKind",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.PackagesNumberKind,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.PackagesNumberKind) = $event)),
            type: "textarea",
            rows: 5,
            resize: "none",
            trim: false,
            placeholder: "如需显示详细的数量，请在此填写，例如“12PLTS=100CNTS”"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_8, [
      _hoisted_9,
      _hoisted_10,
      _createVNode(_component_el_form_item, {
        class: "goods-description",
        prop: "GoodsDescription",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.GoodsDescription,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.GoodsDescription) = $event)),
            type: "textarea",
            rows: 5,
            resize: "none",
            trim: true,
            trimManySpace: true,
            red: _ctx.reds && _ctx.reds.contains('GoodsDescription')
          }, null, 8, ["modelValue", "red"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        class: "goods-description-remark",
        prop: "GoodsDescriptionRemark",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.GoodsDescriptionRemark,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.GoodsDescriptionRemark) = $event)),
            type: "textarea",
            rows: 5,
            resize: "none",
            trim: false,
            placeholder: "请填写其他需要在品名栏显示的信息"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_11, [
      _hoisted_12,
      _hoisted_13,
      _createVNode(_component_el_form_item, {
        prop: "GrossWeight",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.GrossWeight,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.GrossWeight) = $event)),
            pattern: "[0-9.]",
            number: true,
            numberFixed: 2,
            greaterThanNumber: 0,
            red: _ctx.reds && _ctx.reds.contains('GrossWeight'),
            disabled: 
            _ctx.form.Data.Packages?.any((it) => (it.Shapes?.length ?? 0) > 0)
          
          }, null, 8, ["modelValue", "red", "disabled"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_14, [
      _hoisted_15,
      _hoisted_16,
      _createVNode(_component_el_form_item, {
        prop: "Volume",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_miezz_input, {
            modelValue: _ctx.form.Data.Volume,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.Volume) = $event)),
            pattern: "[0-9.]",
            number: true,
            numberFixed: 4,
            greaterThanNumber: 0,
            red: _ctx.reds && _ctx.reds.contains('Volume'),
            disabled: 
            _ctx.form.Data.Packages?.any((it) => (it.Shapes?.length ?? 0) > 0)
          
          }, null, 8, ["modelValue", "red", "disabled"])
        ]),
        _: 1
      })
    ])
  ]))
}